import { authRoles } from "./auth/authRoles";

export const navigations = [
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: "dashboard_customize",
    auth: authRoles.all,
  },
  {
    type: "label",
    label: "Manajemen",
    auth: authRoles.absa,
  },
  {
    name: "Manajemen Perusahaan",
    icon: "manage_accounts",
    auth: authRoles.absa,
    children: [
      {
        name: "Kategori",
        path: "/kategori_manajemen",
        auth: authRoles.absa,
      },
      {
        name: "Data",
        path: "/data_manajemen",
        auth: authRoles.absa,
      },
    ],
  },
  {
    name: "Sertifikat & Penghargaan",
    path: "/sertifikat_penghargaan",
    icon: "military_tech",
    auth: authRoles.absa,
  },
  {
    name: "Anak Perusahaan",
    path: "/anak_perusahaan",
    icon: "account_tree",
    auth: authRoles.absa,
  },
  {
    name: "Pengembangan Properti",
    icon: "corporate_fare",
    auth: authRoles.pm,
    children: [
      {
        name: "Tipe",
        path: "/tipe_property",
        auth: authRoles.pm,
      },
      {
        name: "Data",
        path: "/data_property",
        auth: authRoles.pm,
      },
    ],
  },
  {
    name: "Aset & Investasi Properti",
    icon: "real_estate_agent",
    auth: authRoles.pm,
    children: [
      {
        name: "Tipe",
        path: "/tipe_aset",
        auth: authRoles.pm,
      },
      {
        name: "Data",
        path: "/data_aset",
        auth: authRoles.pm,
      },
    ],
  },
  {
    name: "Hotel",
    path: "/hotel",
    icon: "hotel",
    auth: authRoles.pm,
  },
  {
    name: "Portfolio",
    path: "/portfolio",
    icon: "home_work",
    auth: authRoles.absa,
  },
  {
    name: "Mitra",
    path: "/mitra",
    icon: "handshake",
    auth: authRoles.absa,
  },
  {
    name: "Laporan Tahunan",
    path: "/laporan_tahunan",
    icon: "equalizer",
    auth: authRoles.absa,
  },
  {
    name: "Laporan Keuangan",
    path: "/laporan_keuangan",
    icon: "show_chart",
    auth: authRoles.absa,
  },
  {
    name: "Komite GCG",
    icon: "group",
    auth: authRoles.absa,
    children: [
      {
        name: "Kategori",
        path: "/kategori_komite",
        auth: authRoles.absa,
      },
      {
        name: "Data",
        path: "/data_komite",
        auth: authRoles.absa,
      },
    ],
  },
  {
    name: "Media",
    icon: "newspaper",
    auth: authRoles.absa,
    children: [
      {
        name: "Kategori",
        path: "/kategori_media",
        auth: authRoles.absa,
      },
      {
        name: "Data",
        path: "/data_media",
        auth: authRoles.absa,
      },
    ],
  },
  {
    name: "E-Magazine",
    path: "/e-magazine",
    icon: "auto_stories",
    auth: authRoles.absa,
  },
  {
    name: "Promosi",
    path: "/promosi",
    icon: "confirmation_number",
    auth: authRoles.pm,
  },
  {
    name: "Aktifitas CSR",
    path: "/aktifitas_csr",
    icon: "volunteer_activism",
    auth: authRoles.absa,
  },
  {
    name: "Aktifitas SHE",
    path: "/aktifitas_she",
    icon: "verified_user",
    auth: authRoles.absa,
  },
  {
    name: "Karir",
    icon: "work",
    auth: authRoles.absa,
    children: [
      {
        name: "Departement",
        path: "/departement_karir",
        auth: authRoles.absa,
      },
      {
        name: "Data",
        path: "/data_karir",
        auth: authRoles.absa,
      },
    ],
  },
  {
    name: "Hero Section",
    path: "/hero_section",
    icon: "panorama",
    auth: authRoles.absa,
  },
  {
    name: "Admin",
    path: "/admin",
    icon: "badge",
    auth: authRoles.sa,
  },
  {
    type: "label",
    label: "Halaman",
    auth: authRoles.absa,
  },
  {
    name: "Beranda",
    icon: "home",
    path: "/beranda",
    auth: authRoles.absa,
  },
  {
    name: "Sejarah Perusahaan",
    icon: "history",
    auth: authRoles.absa,
    children: [
      {
        name: "Konten",
        path: "/sejarah_perusahaan",
        auth: authRoles.absa,
      },
      {
        name: "Milestone",
        path: "/milestone",
        auth: authRoles.absa,
      },
      {
        name: "Visi & Misi",
        path: "/visi_misi",
        auth: authRoles.absa,
      },
      {
        name: "Nilai Perusahaan",
        path: "/nilai_perusahaan",
        auth: authRoles.absa,
      },
    ],
  },
  {
    name: "Manajemen Perusahaan",
    icon: "manage_accounts",
    path: "/manajemen_perusahaan",
    auth: authRoles.absa,
  },
  {
    name: "GCG",
    icon: "group",
    auth: authRoles.absa,
    children: [
      {
        name: "Konten",
        path: "/gcg",
        auth: authRoles.absa,
      },
      {
        name: "File",
        path: "/gcg_file",
        auth: authRoles.absa,
      },
    ],
  },
  {
    name: "Karir",
    icon: "work",
    path: "/karir",
    auth: authRoles.absa,
  },
  {
    name: "Kontak Kami",
    icon: "call",
    path: "/kontak_kami",
    auth: authRoles.absa,
  },
  {
    name: "Jenis Pertanyaan",
    icon: "help",
    path: "/jenis_pertanyaan",
    auth: authRoles.absa,
  },
  {
    type: "label",
    label: "Umum",
    auth: authRoles.absa,
  },
  {
    name: "Informasi Umum",
    icon: "info",
    path: "/informasi_umum",
    auth: authRoles.absa,
  },
  {
    name: "Provinsi",
    icon: "storage",
    path: "/provinsi",
    auth: authRoles.absa,
  },
  {
    name: "Kota",
    icon: "storage",
    path: "/kota",
    auth: authRoles.absa,
  },
];
